import React from 'react';
import RadioFieldset from '../../../audi-ui-components/RadioFieldset';
import TextField from '../../../audi-ui-components/TextField';
import RangeSlider from '../../../components/RangeSlider';
import Select from '../../../audi-ui-components/Select';
import Button from '../../../audi-ui-components/Button';
import Spinner from '../../../audi-ui-components/Spinner';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { gtmPush } from '../../../functions/gtm';
import { formatDollar, unFormatNumber } from '../../../functions/textFormatting';

const FEATURE_FREQUENCY = false;

class StepRepayments extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            initialProps: {
                gfv: props.gfv,
                term: props.term,
                frequency: props.frequency,
                deposit: props.deposit,
                balloon: props.balloon,
                kmlimit: props.kmlimit
            },
            term: props.term,
            frequency: props.frequency,
            deposit: props.deposit,
            balloon: props.balloon,
            kmlimit: props.kmlimit,
            submitted: false,
            depositHasFocus: false,
            balloonHasFocus: false
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.balloon === null && this.props.balloon !== null) {
            this.setState({balloon: this.props.balloon});
        }
        if (prevProps.counter !== this.props.counter) {
            // calculation happened
            this.setState({balloon: this.props.balloon});
        }
    }

    componentWillUnmount() {
        if (!this.state.submitted) {
            // reset calculation
            const {initialProps} = this.state;
            this.props.onSubmit({
                gfv: initialProps.gfv,
                term: initialProps.term,
                frequency: initialProps.frequency,
                deposit: initialProps.deposit,
                balloon: initialProps.balloon,
                kmlimit: initialProps.kmlimit
            });
        }
    }

    onSubmit = () => {
        const {frequency, term, deposit, balloon, kmlimit} = this.state;
        gtmPush(
            "afsCalculator", "UpdateRepayments", "AfsCalRepayments",
            {"Frequency": frequency, "LoanTerm": term, "YourDeposit": deposit, "YourBalloon": balloon, "EndChoice": this.props.gfv, "KMLimit": kmlimit}
        );
        // set submitted to prevent reset on componentWillUnmount
        this.setState({submitted: true}, () => {
            this.props.onSubmit({
                frequency: frequency,
                deposit: deposit,
                balloon: balloon,
                kmlimit: kmlimit
            }, true);
        });
    }

    onChangeGfv = (v) => {
        // recalculate
        const {frequency, deposit, balloon, kmlimit} = this.state;
        this.props.onSubmit({
            gfv: v,
            frequency: frequency,
            deposit: deposit,
            balloon: balloon,
            kmlimit: kmlimit
        });
    }

    onChangeTerm = () => {
        // recalculate
        const {term, frequency, deposit, balloon, kmlimit} = this.state;
        this.props.onSubmit({
            term: term,
            frequency: frequency,
            deposit: deposit,
            balloon: balloon,
            kmlimit: kmlimit
        });
    }

    onChangeBalloon = (v) => {
        // validate balloon value
        const {params} = this.props;
        let newV = unFormatNumber(v);
        newV = parseInt(newV);
        if (params.Balloon && params.Balloon.dataValues) {
            let len = params.Balloon.dataValues.length;
            let bMin = parseInt(params.Balloon.dataValues[0]);
            let bMax = parseInt(params.Balloon.dataValues[len - 1]);
            if (newV < bMin) {
                newV = bMin;
            } else if (newV > bMax) {
                newV = bMax;
            }
        }
        this.setState({balloon: newV});
    }

    onCancel = () => {
        gtmPush("afsCalculator", "CancelUpdate", "AfsCalRepayments");
        this.props.onClickCancel();
    }

    renderTerm = () => {
        const {params} = this.props;
        if (params.Term && params.Term.dataValues) {
            let len = params.Term.dataValues.length;
            let termMin = parseInt(params.Term.dataValues[0]);
            let termMax = parseInt(params.Term.dataValues[len - 1]);
            let termStep = parseInt(params.Term.dataValues[1]) - termMin;
            let termLabels = {};
            for (let i=0; i<len; i++) {
                let t = params.Term.dataValues[i];
                termLabels[t] = `${t}`;
            }
            return (
                <RangeSlider
                    min={termMin} max={termMax} step={termStep}
                    value={this.state.term}
                    label={(<p className="label">Choose your loan term (in months)</p>)}
                    labels={termLabels}
                    onChange={(v) => { this.setState({term: v}); }}
                    onChangeComplete={this.onChangeTerm}
                    className="mb-5"
                    theme={this.props.theme}
                />
            );
        }
        return null;
    }

    renderKMLimit = () => {
        const {params} = this.props;
        if (params.KMLimit && params.KMLimit.dataValues) {
            let opts = [];
            let len = params.KMLimit.dataValues.length;
            for (let i=0; i<len; i++) {
                let t = params.KMLimit.dataValues[i];
                opts.push({label: `${t}`, value: t});
            }
            return (
                <Select
                    value={this.state.kmlimit}
                    label={params.KMLimit.label}
                    description={params.KMLimit.help}
                    options={opts}
                    onChange={(v) => {
                        this.setState({kmlimit: v});
                    }}
                    className="mb-5"
                    theme={this.props.theme === "dark" ? "light" : null}
                />
            );
        }
        return null;
    }

    render() {
        const {params, calculating} = this.props;
        let loantypeName = this.props.loantype === "ConsumerLoan" ? "Consumer Loan" : "Chattel Mortgage";
        return (
            <div className="position-relative">
                {calculating && <div className="spinner-wrapper"><Spinner isContinuous /></div>}

                <div style={{maxWidth: '800px'}}>
                    <p className="label mb-2">Your options with {loantypeName}</p>
                    <p className="mb-3">Enjoy a new Audi sooner with 100% finance for approved customers. There’s nothing to pay upfront, no account keeping or annual fees, and our competitive fixed interest rates mean you can budget with confidence<sup>**</sup>.</p>

                    <p className="mb-5">
                        <Button buttonType="text" label="Change loan type" className="back" onClick={this.props.onClickBack} theme={this.props.theme === "dark" ? "light" : null} />
                    </p>

                    {FEATURE_FREQUENCY && <RadioFieldset title="Choose your repayment frequency"
                        options={[
                            { label: 'Weekly', name: 'frequency', value: 'weekly' },
                            { label: 'Fortnightly', name: 'frequency', value: 'fortnightly' },
                            { label: 'Monthly', name: 'frequency', value: 'monthly' }
                        ]}
                        value={this.state.frequency}
                        onChange={(v) => { this.setState({ frequency: v }); }}
                        className="mb-5"
                        theme={this.props.theme === "dark" ? "light" : null}
                    />}

                    {this.renderTerm()}

                    <p className="label mb-2">Tailor your {this.state.frequency} repayments<sup>***</sup></p>
                    <div className="row mb-5">
                        <div className="col-12 col-xsmall-6">
                            <TextField name="deposit"
                                label="Your deposit (optional)"
                                value={this.state.depositHasFocus ? this.state.deposit : formatDollar(this.state.deposit)}
                                onFocus={() => { this.setState({depositHasFocus: true}); }}
                                onBlur={() => { this.setState({depositHasFocus: false}); }}
                                onChange={(v) => {
                                  this.setState({
                                    deposit: unFormatNumber(v),
                                  });
                                }}
                                theme={this.props.theme === "dark" ? "light" : null}
                            />
                            {params.DownPayment && <OverlayTrigger
                                placement="top"
                                trigger="click"
                                overlay={<Popover id="popdeposit"><Popover.Content>{params.DownPayment.help}</Popover.Content></Popover>}
                            >
                                <span className="aui-small aui-textlink">What is this?</span>
                            </OverlayTrigger>}
                        </div>
                        {params.Balloon && <div className="col-12 col-xsmall-6">
                            <TextField name="balloon"
                                label="Your balloon payment (optional)"
                                value={this.state.balloonHasFocus ? this.state.balloon : `${this.state.balloon}%`}
                                onFocus={() => { this.setState({balloonHasFocus: true}); }}
                                onBlur={() => { this.setState({balloonHasFocus: false}); }}
                                onChange={this.onChangeBalloon}
                                theme={this.props.theme === "dark" ? "light" : null}
                            />
                            <OverlayTrigger
                                placement="top"
                                trigger="click"
                                overlay={<Popover id="popballoon"><Popover.Content>{params.Balloon.help}</Popover.Content></Popover>}
                            >
                                <span className="aui-small aui-textlink">What is this?</span>
                            </OverlayTrigger>
                        </div>}
                    </div>

                    {this.props.gfvAllowed && <div>
                        <p className="label mb-2">What would you like to do at the end of the loan term?</p>
                        <p>At the end of your loan term you can keep your Audi or trade it in for a new one with a standard loan, or have the additional option of returning it back to the dealership with Audi Choice^.</p>
                        <RadioFieldset
                            options={[
                                { label: 'Audi Choice', name: 'gfv', value: 'AudiChoice' },
                                { label: 'Standard loan', name: 'gfv', value: 'custom' }
                            ]}
                            value={this.props.gfv}
                            onChange={this.onChangeGfv}
                            theme={this.props.theme === "dark" ? "light" : null}
                        />
                    </div>}

                    {this.renderKMLimit()}
                </div>

                <div className="row mt-5">
                    <div className="col-auto">
                        <Button buttonType="text" label="Back" className="back" onClick={this.props.onClickBack} theme={this.props.theme === "dark" ? "light" : null} />
                    </div>
                    <div className="col">
                        <div className="row justify-content-end">
                            <div className="col-12 col-small-auto mb-3 mb-small-0">
                                <Button
                                    label="Cancel changes"
                                    buttonType="secondary"
                                    onClick={this.onCancel}
                                    theme={this.props.theme === "dark" ? "light" : null}
                                />
                            </div>
                            <div className="col-12 col-small-auto">
                                <Button
                                    label="Update"
                                    buttonType="primary"
                                    onClick={this.onSubmit}
                                    theme={this.props.theme === "dark" ? "light" : null}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default StepRepayments;
